import React from "react";
import http from '../modules/api';

export class TermsCndtnForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // terms: props.terms,
            terms: props.terms,
            terms_title: "",
            terms_code: "",
        }
    }

    state = { showType: true }

    componentDidMount () {
        this.getFormTernm('robomd', this.state.terms);
    }

    //약관 조회
    getFormTernm(form_cls, form_type) {
    http.get("/rest/common/fromIframe", 
        {
            params:{
                form_cls : form_cls,
                form_type : form_type
            }
        })
        .then(res => {
        this.setState({
            terms_code : res.data.list.length > 0 ? res.data.list[0].content : "",
            terms_title : res.data.list.length > 0 ? res.data.list[0].form_title : ""
        });

        // for(var idx in res.data) {
        //     var name = "pageNumber_"+res.data[idx]["form_seq"]
        //     var name_agree = "agree_"+res.data[idx]["form_seq"]
        //     this.setState( {[name]: 1,
        //     [name_agree]: "N"});
        // }
        })
        .catch(err => { 
            alert("가입약관 조회 에러"); 
        });
    }

    handleCloseBtn = () => { this.props.termsClick("close"); }

    render() {
        return (
            <>
                <div className="only_terms_page login_style_guide">
                    <div className="terms">
                        <div className="terms_header">
                            <h2>
                                {this.state.terms_title}
                            </h2>
                            <svg onClick={this.handleCloseBtn} className="close_btn" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.2847 18.2154C19.4255 18.3575 19.5045 18.5496 19.5045 18.7497C19.5045 18.9499 19.4255 19.1419 19.2847 19.2841C19.1413 19.4227 18.9497 19.5002 18.7503 19.5002C18.5509 19.5002 18.3593 19.4227 18.2159 19.2841L12.0003 13.0591L5.78469 19.2841C5.64133 19.4227 5.44972 19.5002 5.25031 19.5002C5.0509 19.5002 4.85929 19.4227 4.71594 19.2841C4.5751 19.1419 4.49609 18.9499 4.49609 18.7497C4.49609 18.5496 4.5751 18.3575 4.71594 18.2154L10.9409 11.9997L4.71594 5.7841C4.59634 5.63838 4.53522 5.45338 4.54447 5.26509C4.55372 5.0768 4.63267 4.89869 4.76597 4.76539C4.89927 4.63208 5.07739 4.55313 5.26568 4.54388C5.45397 4.53464 5.63897 4.59575 5.78469 4.71535L12.0003 10.9404L18.2159 4.71535C18.3617 4.59575 18.5467 4.53464 18.7349 4.54388C18.9232 4.55313 19.1014 4.63208 19.2347 4.76539C19.368 4.89869 19.4469 5.0768 19.4562 5.26509C19.4654 5.45338 19.4043 5.63838 19.2847 5.7841L13.0597 11.9997L19.2847 18.2154Z" fill="#333333"/></svg>
                        </div>
                        <div className="terms_body" style={{padding: "20px"}}>
                            <div id="listArea" style={{marginTop:"50px", marginBottom:"20px", fontWeight:"bold", fontSize:"11pt"}}>
                                {/* <pre
                                    dangerouslySetInnerHTML={ {__html: 
                                        this.state.terms_code
                                    } }>
                                </pre> */}
                                <li>
                                    <a href='list[idx].s3_url' target='_blank' style={{color:"#333333", fontWeight:"normal"}} 
                                        dangerouslySetInnerHTML={ {__html: 
                                            this.state.terms_code
                                     }}></a>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}